import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/icon';

// The "Gavemedlemskap" entry point. A plain link to the gift registration page
// (/bli-medlem/gave), where the member-registration island mounts with gift=true
// and starts the gift flow. Styled as the form's red CTA. Extracted out of the
// island so editors can place it on any page.
const GIFT_URL = '/bli-medlem/gave';

const GiftMembershipCta = ({ buttonText }) => (
  <div className="gift-membership-cta">
    <a className="gift-membership-cta__button" href={GIFT_URL}>
      {/* CMS sends null/empty when the field is blank; fall back to the default. */}
      <span className="gift-membership-cta__label">
        {buttonText || 'Kjøp gavemedlemskap'}
      </span>
      <span className="gift-membership-cta__icon">
        <Icon name="arrow-right" />
      </span>
    </a>
  </div>
);

GiftMembershipCta.defaultProps = {
  buttonText: 'Kjøp gavemedlemskap'
};

GiftMembershipCta.propTypes = {
  buttonText: PropTypes.string
};

export default GiftMembershipCta;
